import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import { translate } from "@classdojo/web/utils/translate";
import { SyntheticEvent, useMemo } from "react";

type CommentSectionProps = {
  comment: string;
  updateComment: (event: SyntheticEvent<HTMLTextAreaElement>) => void;
  innerHeight: number;
};

export default function CommentSection({ comment, updateComment, innerHeight }: CommentSectionProps) {
  const textAreaCols = useMemo(() => {
    if (innerHeight <= 650) return 30;
    if (innerHeight >= 1000) return 50;
    return 33;
  }, [innerHeight]);

  const textAreaHeight = useMemo(() => {
    if (innerHeight <= 670) return 150;
    return 190;
  }, [innerHeight]);

  const textAreaFontSize = useMemo(() => {
    if (innerHeight <= 670) return 16;
    return 18;
  }, [innerHeight]);

  return (
    <div
      sx={{
        maxWidth: 520,
        marginLeft: RAW_cssValue("auto"),
        marginRight: RAW_cssValue("auto"),
        marginTop: RAW_cssValue(10),
      }}
    >
      <textarea
        cols={textAreaCols}
        sx={{
          padding: RAW_cssValue(20),
          borderRadius: "dt_radius_m",
          border: "dt_card",
          outline: "none",
          fontWeight: 600,
          fontSize: textAreaFontSize,
          lineHeight: 1.33,
          color: "dt_content_primary",
          height: textAreaHeight,
        }}
        value={comment}
        onChange={updateComment}
        placeholder={translate("dojo.beyond:nps_survey.comment_placeholder")}
      />
    </div>
  );
}
